import { Container } from "@mui/material";
import React from "react";
import { IpgCoreviewMainPageComponent } from "../components/pages/coreview/IPGPageComponent";
import { TransactionContractCoreviewMainPageComponent } from "../components/pages/coreview/TransactionContractCoreviewMainPageComponent";
import { TransactionReceiptCoreviewMainPageComponent } from "../components/pages/coreview/TransactionReceiptPageComponent";

export const IpgCoreviewPage = (props) => {
  return (
    <Container maxWidth="xs" disableGutters={true}>
      <TransactionReceiptCoreviewMainPageComponent
        urlParams={props.match.params}
        autoOpenApp={true}
      />
    </Container>
  );
};
export const TransactionReceiptCoreviewPage = (props) => {
  return (
    <Container
      maxWidth="lg"
      disableGutters={true}
      style={{ minWidth: "1024px" }}
    >
      <TransactionContractCoreviewMainPageComponent
        urlParams={props.match.params}
      />
    </Container>
  );
};
